import React, { useState } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import LineIcon from '../LineIcon';
import AlertModal from '../alertModal/AlertModal';
import Logo from '../../assets/img/sobre-rodas.png';
// Estilo compartilhado das areas logadas (cliente e oficina): classes gs-*.
import '../../garage/garage.css';

function NavItems({ nav, className }) {
  return nav.map((item) => (
    <NavLink
      key={item.to}
      to={item.to}
      className={className}
      activeClassName='is-active'
      isActive={(match, location) => Boolean(match) || (item.also || []).some((path) => location.pathname.startsWith(path))}
    >
      <span className='gs-nav-icon'>
        <LineIcon name={item.icon} />
      </span>
      <span>{item.label}</span>
    </NavLink>
  ));
}

/**
 * Moldura das areas logadas: header compacto (logo, aviso e perfil), sidebar no desktop
 * e barra de abas no celular.
 * nav: [{ to, label, icon (nome do LineIcon), also? }] (ate 4 itens cabem na barra de abas).
 * alert: { count, label, to } mostra o sino com ponto quando count > 0.
 * profile: { to, initials, label } atalho do avatar.
 * onLogout: encerra a sessao; o Sair fica no header (celular) e no rodape da sidebar (desktop).
 */
export default function AppShell({ nav, homePath, homeLabel, alert, profile, onLogout, banner, children }) {
  const history = useHistory();
  const hasAlert = alert && alert.count > 0;
  const [confirmLogout, setConfirmLogout] = useState(false);
  const askLogout = () => setConfirmLogout(true);

  return (
    <div className={`gs-page${banner ? ' has-banner' : ''}`}>
      {banner}
      <header className='gs-header'>
        <div className='gs-header-inner'>
          <button type='button' className='gs-logo' onClick={() => history.push(homePath)} aria-label={homeLabel}>
            <img src={Logo} alt='Sobre Rodas' />
          </button>

          <div className='gs-header-actions'>
            {alert && (
              <Link
                to={alert.to}
                className='gs-header-btn'
                aria-label={hasAlert ? alert.label : 'Nenhuma novidade'}
                title={hasAlert ? alert.label : 'Nenhuma novidade'}
              >
                <LineIcon name='bell' />
                {hasAlert && <span className='gs-dot' aria-hidden='true' />}
              </Link>
            )}
            {profile && (
              <Link to={profile.to} className='gs-avatar' aria-label={profile.label} title={profile.label}>
                {profile.initials}
              </Link>
            )}
            {onLogout && (
              <button type='button' className='gs-header-btn gs-header-logout' onClick={askLogout} aria-label='Sair' title='Sair'>
                <LineIcon name='logout' />
              </button>
            )}
          </div>
        </div>
      </header>

      <nav className='gs-sidebar' aria-label='Navegação principal'>
        <NavItems nav={nav} className='gs-side-link' />
        {onLogout && (
          <button type='button' className='gs-side-link gs-side-logout' onClick={askLogout}>
            <span className='gs-nav-icon'>
              <LineIcon name='logout' />
            </span>
            <span>Sair</span>
          </button>
        )}
      </nav>

      <main className='gs-main'>
        <div className='gs-container'>{children}</div>
      </main>

      <nav className='gs-tabbar' aria-label='Navegação principal' style={{ gridTemplateColumns: `repeat(${nav.length}, 1fr)` }}>
        <NavItems nav={nav} className='gs-tab' />
      </nav>

      {onLogout && (
        <AlertModal
          show={confirmLogout}
          message='Deseja sair da sua conta?'
          onHide={() => setConfirmLogout(false)}
          onCancel={() => setConfirmLogout(false)}
          onSubmit={onLogout}
        />
      )}
    </div>
  );
}
